import classNames from 'classnames';
import uikit from '../../../../project/uikit/styles';
import RenderElemet from './RenderElemet';
import css from '../Skeleton.module.scss';
import { generateStylers } from '../../../../common/utils/styles';
const RenderRow = ({ row, itemsShiners, darkMode }) => {
    const { className, style } = generateStylers(row?.itemsStyles);
    return (
        <div
            style={{
                ...uikit.flexRow,
                ...(row?.vertical !== 'unset' ? uikit.alignItemsCenter : {}),
                ...(row?.align !== 'left'
                    ? row?.align === 'center'
                        ? uikit.justifyContentCenter
                        : uikit.justifyContentBetween
                    : {}),
                ...uikit.flexWrap,
                ...(row?.gap
                    ? {
                          ...uikit[`ml${row?.gap}_minus`],
                          ...uikit[`mr${row?.gap}_minus`]
                      }
                    : {}),
                ...(row?.indent
                    ? {
                          ...uikit[`pl${row?.indent}`],
                          ...uikit[`pr${row?.indent}`]
                      }
                    : {})
            }}
        >
            {row?.row.map((width, index) => {
                const item = row?.items?.[index] || row?.items?.[0];
                return (
                    <div
                        key={`RenderRow_${index}`}
                        className={item !== 'empty' ? className : ''}
                        style={{
                            width: width === 'auto' ? width : `${width}%`,
                            ...(row?.gap
                                ? {
                                      ...uikit[`pl${row?.gap}`],
                                      ...uikit[`pr${row?.gap}`]
                                  }
                                : {}),
                            ...(item !== 'empty' ? style : {}),
                            ...(itemsShiners
                                ? {
                                      ...uikit.positionRelative,
                                      overflow: 'hidden'
                                  }
                                : {})
                        }}
                    >
                        <div
                            key={`RenderRow_${index}`}
                            style={
                                itemsShiners
                                    ? {
                                          ...uikit.positionRelative,
                                          overflow: 'hidden'
                                      }
                                    : {}
                            }
                        >
                            {itemsShiners ? (
                                <div className={classNames(css.shine, css.shiner, darkMode ? css.shiner_dark : '')} />
                            ) : null}
                            {item?.row ? (
                                <RenderRow darkMode={darkMode} row={item} />
                            ) : item?.content ? (
                                item?.content?.map((contentItem, i) => {
                                    if (contentItem?.row) {
                                        return (
                                            <RenderRow
                                                darkMode={darkMode}
                                                row={contentItem}
                                                key={`RenderElemets_${index}_${i}`}
                                            />
                                        );
                                    }
                                    return (
                                        <RenderElemet
                                            darkMode={darkMode}
                                            element={contentItem}
                                            key={`RenderElemets_${index}_${i}`}
                                        />
                                    );
                                })
                            ) : (
                                <RenderElemet darkMode={darkMode} element={item} />
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
export default RenderRow;
